// src/services/bi/charts/AverageScoreByFormationChart.jsx
import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

const AverageScoreByFormationChart = ({ data, selectedFormation }) => {

  const filteredData = useMemo(() => {
    if (!data) return [];

    if (selectedFormation === 'all') {
      return data.map(f => ({
        ...f,
        name: f.formation_name || f.intitule,
        score: f.average_score || 0,
      }));
    }

    const selected = data.find(f => f.id === parseInt(selectedFormation));
    return selected ? [{
      ...selected,
      name: selected.formation_name || selected.intitule,
      score: selected.average_score || 0,
    }] : [];
  }, [data, selectedFormation]);

  const getScoreColor = (score) => {
    if (score >= 80) return '#f97316';
    if (score >= 60) return '#a855f7';
    if (score >= 40) return '#3b82f6';
    return '#ef4444';
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const d = payload[0].payload;
      return (
        <div className="score-chart-tooltip">
          <p className="score-chart-tooltip__title">{d.name}</p>
          <p className="score-chart-tooltip__score">{d.score}%</p>
          <p className="score-chart-tooltip__prospects">
            {d.prospect_count || 0} prospects
          </p>
        </div>
      );
    }
    return null;
  };

  // Label au-dessus de chaque barre
  const renderCustomLabel = (props) => {
    const { x, y, width, value } = props;
    return (
      <text
        x={x + width / 2}
        y={y - 6}
        fill="#555"
        textAnchor="middle"
        fontSize={11}
        fontWeight="600"
      >
        {value}%
      </text>
    );
  };

  return (
    <div className="average-score-chart">
      <ResponsiveContainer width="100%" height={260}>
        <BarChart
          data={filteredData}
          layout="horizontal"
          margin={{ top: 25, right: 10, left: 10, bottom: 40 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />

          {/* Formations en axe X (en bas) */}
          <XAxis
            dataKey="name"
            type="category"
            tick={{ fontSize: 11, fill: '#6b7280' }}
            interval={0}
            angle={-20}
            textAnchor="end"
            tickLine={false}
          />

          {/* Scores en axe Y (à gauche) */}
          <YAxis
            type="number"
            domain={[0, 100]}
            tick={{ fontSize: 11, fill: '#6b7280' }}
            tickLine={false}
            axisLine={false}
            tickFormatter={(v) => `${v}`}
          />

          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(0,0,0,0.04)' }} />

          <Bar
            dataKey="score"
            radius={[6, 6, 0, 0]}
            label={renderCustomLabel}
            maxBarSize={50}
          >
            {filteredData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={getScoreColor(entry.score)} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      {/* Info box score moyen */}
      <div className="score-chart-info">
        {filteredData.length > 0 ? (
          <div className="score-chart-info__content">
            <span className="score-chart-info__label">Score moyen global :</span>
            <span className="score-chart-info__value">
              {Math.round(filteredData.reduce((sum, f) => sum + f.score, 0) / filteredData.length)}%
            </span>
          </div>
        ) : (
          <p className="score-chart-info__empty">Aucune donnée disponible</p>
        )}
      </div>
    </div>
  );
};

export default AverageScoreByFormationChart;